import {Modal} from '@logistics-frontend/blocks'
import clsx from 'clsx'
import {type ReactElement, memo} from 'react'

import * as classes from './FullscreenPanel.classes'
import type {Props} from './types'

export const FullscreenPanel = memo<Props>(function FullscreenPanel(props: Props): ReactElement {
  const {opened, anchor = 'bottom', color, className, ...respProps} = props

  return (
    <Modal.SidePanel
      anchor={anchor}
      opened={opened}
      {...respProps}
      className={clsx(classes.sidePanel, classes.anchor[anchor], color && classes.color[color], className)}
    />
  )
})
